import { get, post, put, deleted } from '..';
import routes from './routes';

const DeliveryTypeServices = {
  createDeliveryType: async (obj) => {
    const data = await post(routes.createDeliveryType, obj);
    return data;
  },
  getDeliveryTypes: async (params) => {
    const data = await get(routes.getDeliveryTypes, params);
    return data;
  },
  getDeliveryTypeById: async (id) => {
    const data = await get(routes.getDeliveryTypeById + id);
    return data;
  },
  updateDeliveryType: async (id, obj) => {
    const data = await put(routes.updateDeliveryType + id, obj);
    return data;
  },
  deleteDeliveryType: async (id) => {
    const data = await deleted(routes.deleteDeliveryType + id);
    return data;
  },
}

export default DeliveryTypeServices